const regNumbers = /^[0-9]+$/
export default regNumbers
